import type { SubheadingBlock as SubheadingBlockType } from '../types';

// ─────────────────────────────────────────────
// SubheadingBlock — 章节大标题（H2，加粗）
// ─────────────────────────────────────────────
export function SubheadingBlock({ block }: { block: SubheadingBlockType }) {
  if (!block.text) return null;
  return <h2 className="text-[18px] font-bold text-[#09090B] leading-[1.4]">{block.text}</h2>;
}
